import { render } from "./AddCriminalModal.vue?vue&type=template&id=f90856d0"
import script from "./AddCriminalModal.vue?vue&type=script&lang=js"
export * from "./AddCriminalModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__